import {
  BLOCK_OPTIONS
} from "#blokkli-build/runtime-options";
import {
  bundlesWithVisibleLanguage,
  bundlesWithHiddenGlobally
} from "#blokkli-build/default-global-options";
import { BK_HIDDEN_GLOBALLY, BK_VISIBLE_LANGUAGES } from "../symbols.js";
export function mapCheckboxTrue(v) {
  return v === true || v === "1" || v === 1 || v === "true" ? "1" : "0";
}
export function getRuntimeOptionValue(definition, value) {
  const type = Array.isArray(definition) ? definition[0] : definition.type;
  const defaultValue = Array.isArray(definition) ? definition[1] : definition.default;
  if (value === null || value === void 0) {
    return defaultValue;
  }
  if (type === "checkbox") {
    return mapCheckboxTrue(value) === "1";
  } else if (type === "radios") {
    if (typeof value === "string") {
      return value;
    }
  } else if (type === "checkboxes") {
    if (typeof value === "string") {
      return value.split(",");
    } else if (Array.isArray(value)) {
      return value;
    }
  } else if (type === "range" || type === "number") {
    if (typeof value === "number" && !Number.isNaN(value)) {
      return value;
    } else if (typeof value === "string") {
      const parsed = Number.parseFloat(value);
      if (!Number.isNaN(parsed)) {
        return parsed;
      }
    }
  } else if (type === "color") {
    if (typeof value === "string") {
      if (value.startsWith("#")) {
        return value;
      } else if (value.length === 6) {
        return `#${value}`;
      }
    }
  } else if (type === "text" && typeof value === "string") {
    return value;
  }
  return defaultValue;
}
export function isVisibleByOptions(item, language) {
  if (!item) {
    return false;
  }
  if (item.options) {
    if (bundlesWithHiddenGlobally.includes(item.bundle) && mapCheckboxTrue(item.options[BK_HIDDEN_GLOBALLY]) === "1") {
      return false;
    }
    if (bundlesWithVisibleLanguage.includes(item.bundle)) {
      const option = item.options[BK_VISIBLE_LANGUAGES];
      if (language && option && typeof option === "string") {
        const languages = option.split(",");
        if (languages.length && !languages.includes(language)) {
          return false;
        }
      }
    }
  }
  return true;
}
export function getRuntimeOptions(item, fromLibraryOptions) {
  if (item.bundle === "from_library" && "libraryItem" in item.props) {
    const actualBlock = item.props.libraryItem?.block;
    if (!actualBlock) {
      throw new Error("Missing block");
    }
    return getRuntimeOptions(
      actualBlock,
      item.options
    );
  }
  const availableOptions = BLOCK_OPTIONS[item.bundle] || {};
  return Object.entries(availableOptions).reduce(
    (acc, [key, definition]) => {
      if (fromLibraryOptions && fromLibraryOptions[key] !== void 0 && fromLibraryOptions[key] !== null) {
        acc[key] = getRuntimeOptionValue(
          definition,
          fromLibraryOptions.value[key]
        );
        return acc;
      }
      if (item.options && item.options[key] !== void 0 && item.options[key] !== null) {
        acc[key] = getRuntimeOptionValue(definition, item.options[key]);
        return acc;
      }
      acc[key] = definition[1];
      return acc;
    },
    {}
  );
}
export function getActualBlock(item) {
  if (item.bundle === "from_library") {
    const block = item.props.libraryItem?.block;
    if (!block) {
      return null;
    }
    const mergedOptions = {
      ...item.options || {},
      ...block.options || {}
    };
    return { ...block, options: mergedOptions };
  }
  return item;
}
export function getItemsforBundles(items, bundles) {
  const filtered = [];
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    if (item.bundle === "from_library") {
      const actual = getActualBlock(item);
      if (actual && bundles.includes(actual.bundle)) {
        filtered.push(actual);
      }
    } else if (bundles.includes(item.bundle)) {
      filtered.push(item);
    }
  }
  return filtered;
}
